import { useMutation } from "@tanstack/react-query";
import clienteAxios from "../../helpers/clienteAxios";
import { useLoading } from "../../context/loadingContext";

const api = async (params) => {
  const { data } = await clienteAxios.post("/sucursalVirtual/crm/portabilidadMP/enviarCodigoValidacion", params);
  return data;
};

const useEnviarSms = () => {

  const { setLoading, removeLoading } = useLoading();

  return useMutation(api, {
    onSuccess: (response) => {
      removeLoading({ id: "enviarSms" });
    },
    onError: (error) => {
      removeLoading({ id: "enviarSms" });
      //toast.error(error.response.data.error.detalleRespuesta)
    },
    onMutate: () => {
      setLoading({ id: "enviarSms", message: "Por favor espere..." });
    },
  });
};

export default useEnviarSms;
